import React, { useEffect, useRef, useState } from 'react';

type BundlingTimerProps = {
  timeLeft?: number;
  className?: string;
  onTimerEnd?: () => void;
  deps?: any[];
};

const BundlingTimer = (props?: BundlingTimerProps) => {
  const [bundlingTimerLeft, setBundlingTimerLeft] = useState(null);
  const bundlingTimerInterval = useRef<any>();
  const { timeLeft, className, onTimerEnd, deps } = props;

  useEffect(
    () => () => {
      clearInterval(bundlingTimerInterval?.current);
    },
    [],
  );

  useEffect(() => {
    // Check if the interval already exists, if it does, don't do anything
    if (bundlingTimerInterval.current) {
      clearInterval(bundlingTimerInterval.current);
    }

    // If bundling option has a timer, start it
    if (Number.isInteger(timeLeft)) {
      const initialTimeLeft = Number.isInteger(bundlingTimerLeft) ? bundlingTimerLeft : timeLeft;

      setBundlingTimerLeft(initialTimeLeft);

      let counter = 0;

      bundlingTimerInterval.current = setInterval(() => {
        counter += 1;

        const newTimeLeft = initialTimeLeft - counter;

        // If the timer runs out, clear the interval and disable bundling option
        if (newTimeLeft <= 0) {
          setBundlingTimerLeft(0);

          // set bundling option as disabled
          if (typeof onTimerEnd === 'function') {
            onTimerEnd();
          }

          clearInterval(bundlingTimerInterval.current);

          return;
        }

        setBundlingTimerLeft(newTimeLeft);
      }, 1000);
    }
  }, [timeLeft, ...(deps || [])]);

  // Converts seconds into human readable string
  const secondsToHumanReadable = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const leftSeconds = seconds - minutes * 60;

    return `${minutes}m ${leftSeconds}s`;
  };

  return (
    <>
      {(bundlingTimerLeft || Number.isInteger(bundlingTimerLeft)) && timeLeft && (
        <span className={className}>{secondsToHumanReadable(bundlingTimerLeft)}</span>
      )}
    </>
  );
};

export default BundlingTimer;
